exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-trigger[data-v-eefc680a]{z-index:999;margin-left:20px;width:65px;height:65px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#fff;background-color:#e8b88b;-webkit-transition:background-color .5s;transition:background-color .5s;font-size:21px}.menu-trigger[data-v-eefc680a]:hover{cursor:pointer;background-color:#eda460}", ""]);

// exports
